import React from 'react';
import AuthStore from 'stores/AuthStore';
import classNames from 'classnames';
import {Link} from 'react-router';
import 'styles/admin/DashboardSidebar.styl';
import hasFeature from 'utils/hasFeature';

function getUrl(menuItem) {
  return menuItem && (menuItem.url || (menuItem.children && getUrl(menuItem.children.get(0))));
}

/**
 * Generic Sidebar used for each role's dashboard
 */
class DashboardSidebar extends React.Component {
  renderMenu(menu, topLevel) {
    const menuClassName = classNames('menu', {
      'sub-menu': !topLevel,
    });
    if (menu && !menu.isEmpty()) {
      return (
        <div className={menuClassName}>
          {menu.filter(getUrl).map((item, i) => {
            // check if any child link is active
            const currentTabLocation = window.location.pathname;
            const childActive =
              new RegExp(getUrl(item)).test(currentTabLocation) ||
              (item.children &&
                item.children.some(child => new RegExp(getUrl(child)).test(currentTabLocation)));

            const linkContainerClassName = classNames(
              'link-container',
              {
                'child-active': childActive && topLevel,
              },
              this.props.className
            );

            const linkClassName = classNames(
              'link',
              {
                'disabled-link': item.disabled,
                parent: item.children,
              },
              this.props.className
            );

            return (
              <div className={linkContainerClassName} key={i}>
                <Link
                  key={i}
                  data-key={item.name}
                  to={getUrl(item)}
                  activeClassName="active"
                  className={linkClassName}>
                  {item.icon && <item.icon />}
                  {item.name}
                </Link>
                {childActive && this.renderMenu(item.children, false)}
              </div>
            );
          })}
        </div>
      );
    }
  }

  render() {
    const user = AuthStore.getState().user;
    const accessibilityFilter = ({flag, notFlag}) =>
      hasFeature(user.flags, flag) && !(notFlag && hasFeature(user.flags, notFlag));

    const filterChildren = menuItem => ({
      ...menuItem,
      children:
        menuItem.children && menuItem.children.filter(accessibilityFilter).map(filterChildren),
    });
    const accessibleMenu = this.props.sidebarMenu.filter(accessibilityFilter).map(filterChildren);

    // update className depending on 'sidebarOpen'
    const className = classNames('admin-app-sidebar', {
      open: this.props.sidebarOpen,
      closed: !this.props.sidebarOpen,
    });

    return (
      <div className={className}>
        {this.renderMenu(accessibleMenu, true)}
        {this.props.children}
      </div>
    );
  }
}

export default DashboardSidebar;
